var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        visible: _vm.status,
        "no-close-on-backdrop": true,
        "body-class": "p-3 text-left",
        size: "lg",
        title: "Form"
      },
      on: { ok: _vm.saveItem, hide: _vm.closeModal, cancel: _vm.closeModal }
    },
    [
      _vm.loading
        ? _c("p", [_vm._v("Loading...")])
        : _c("form-component", {
            attrs: {
              timestamp: _vm.localTimestamp,
              type: _vm._.get(_vm.localContent, "type"),
              id: _vm._.get(_vm.localContent, "id"),
              attributes: _vm._.get(_vm.localContent, "attributes", {}),
              meta: _vm._.get(_vm.localContent, "meta", {}),
              schema: _vm._.get(_vm.localContent, "schema.attributes", {}),
              config: _vm.formConfig,
              resourceParams: _vm.resourceParams,
              changeUrl: _vm.doNothing,
              changeSection: _vm.doNothing,
              changeQuery: _vm.doNothing,
              addNotification: _vm.addNotification,
              createData: _vm.modifiedCreateData,
              updateData: _vm.modifiedUpdateData,
              deleteData: _vm.deleteData,
              commitQueue: _vm.doNothing,
              pushQueue: _vm.doNothing,
              onInitialized: _vm.registerSubmit,
              onChanged: _vm.updateLocalContent,
              onCreated: _vm.onCreated,
              onUpdated: _vm.onUpdated,
              onDeleted: _vm.doNothing
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03bc5872", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03bc5872","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/FormModalComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-03bc5872","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/FormModalComponent.vue
// module chunks = 0